import { useQuery } from '@tanstack/react-query'

const fetchNetworkStatus = async (): Promise<'Good' | 'Bad'> => {
  try {
    const start = performance.now()
    await fetch('https://www.google.com/favicon.ico', { mode: 'no-cors' })
    const latency = performance.now() - start

    const connection =
      (navigator as any).connection || (navigator as any).mozConnection || (navigator as any).webkitConnection
    const downlink = connection?.downlink || 0 // Speed in Mbps

    return latency < 100 && downlink > 5 ? 'Good' : 'Bad'
  } catch {
    return 'Bad'
  }
}

const NetworkStatus = () => {
  const { data: status, isLoading, isError } = useQuery({
    queryKey: ['networkStatus'],
    queryFn: fetchNetworkStatus,
    refetchInterval: 10000, // Auto-refetch every 10 seconds
    staleTime: 10000 // Avoid unnecessary re-fetching
  })

  return (
    <div
      className='rounded-full px-2 py-1 text-xs'
      style={{ backgroundColor: status === 'Good' ? 'green' : 'red' }}
    >
      {isLoading ? 'Checking...' : isError ? 'Error' : `Network Health: ${status}`}
    </div>
  )
}

export default NetworkStatus
